import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ReturnSettingsApi - axios parameter creator
 * @export
 */
const ReturnSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Όλες οι μεταβλητές του module με την τιμή τους για το ενεργό site. (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/ReturnSettings/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Η ακύρωση της cache γίνεται <b>ρητά</b>, όχι με `CacheInvalidationActionFilter`. Το φίλτρο καλεί `ClearInvalidCache`, που διαβάζει τον `CachedEntitiesControl` από δική του σύνδεση και <i>προσπερνά</i> κάθε tag γραμμένο τα τελευταία `InvalidationSettleSeconds` — δηλαδή ακριβώς αυτό που μόλις έγραψε ο trigger του `Settings`. Το αποτέλεσμα θα ήταν το `ReturnSettings-{siteId}` να μείνει μπαγιάτικο μέχρι το επόμενο πέρασμα του `CachingHostedService`. Το `CheckCacheValidity` είναι in-memory και άμεσο, και είναι το μοτίβο που ήδη χρησιμοποιούν οι controllers με ρύθμιση που πρέπει να ισχύσει μέσα στο ίδιο request. Χωρίς `UnitOfWorkActionFilter`: μία μόνο εγγραφή, την οποία κάνει commit η ίδια η υπηρεσία, όπως και ο `SettingsController`.
         * @summary Αποθηκεύει μία μεταβλητή. Κενή τιμή διαγράφει τη γραμμή που ισχύει και επαναφέρει την προεπιλογή. (Auth roles: System)
         * @param {ReturnSettingUpdateArgs} [ReturnSettingUpdateArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (ReturnSettingUpdateArgs, options = {}) => {
            const localVarPath = `/v1/ReturnSettings/Put`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReturnSettingUpdateArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReturnSettingsApi - functional programming interface
 * @export
 */
const ReturnSettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReturnSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Όλες οι μεταβλητές του module με την τιμή τους για το ενεργό site. (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnSettingsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Η ακύρωση της cache γίνεται <b>ρητά</b>, όχι με `CacheInvalidationActionFilter`. Το φίλτρο καλεί `ClearInvalidCache`, που διαβάζει τον `CachedEntitiesControl` από δική του σύνδεση και <i>προσπερνά</i> κάθε tag γραμμένο τα τελευταία `InvalidationSettleSeconds` — δηλαδή ακριβώς αυτό που μόλις έγραψε ο trigger του `Settings`. Το αποτέλεσμα θα ήταν το `ReturnSettings-{siteId}` να μείνει μπαγιάτικο μέχρι το επόμενο πέρασμα του `CachingHostedService`. Το `CheckCacheValidity` είναι in-memory και άμεσο, και είναι το μοτίβο που ήδη χρησιμοποιούν οι controllers με ρύθμιση που πρέπει να ισχύσει μέσα στο ίδιο request. Χωρίς `UnitOfWorkActionFilter`: μία μόνο εγγραφή, την οποία κάνει commit η ίδια η υπηρεσία, όπως και ο `SettingsController`.
         * @summary Αποθηκεύει μία μεταβλητή. Κενή τιμή διαγράφει τη γραμμή που ισχύει και επαναφέρει την προεπιλογή. (Auth roles: System)
         * @param {ReturnSettingUpdateArgs} [ReturnSettingUpdateArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(ReturnSettingUpdateArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(ReturnSettingUpdateArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnSettingsApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReturnSettingsApi - factory interface
 * @export
 */
const ReturnSettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReturnSettingsApiFp(configuration);
    return {
        /**
         *
         * @summary Όλες οι μεταβλητές του module με την τιμή τους για το ενεργό site. (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Η ακύρωση της cache γίνεται <b>ρητά</b>, όχι με `CacheInvalidationActionFilter`. Το φίλτρο καλεί `ClearInvalidCache`, που διαβάζει τον `CachedEntitiesControl` από δική του σύνδεση και <i>προσπερνά</i> κάθε tag γραμμένο τα τελευταία `InvalidationSettleSeconds` — δηλαδή ακριβώς αυτό που μόλις έγραψε ο trigger του `Settings`. Το αποτέλεσμα θα ήταν το `ReturnSettings-{siteId}` να μείνει μπαγιάτικο μέχρι το επόμενο πέρασμα του `CachingHostedService`. Το `CheckCacheValidity` είναι in-memory και άμεσο, και είναι το μοτίβο που ήδη χρησιμοποιούν οι controllers με ρύθμιση που πρέπει να ισχύσει μέσα στο ίδιο request. Χωρίς `UnitOfWorkActionFilter`: μία μόνο εγγραφή, την οποία κάνει commit η ίδια η υπηρεσία, όπως και ο `SettingsController`.
         * @summary Αποθηκεύει μία μεταβλητή. Κενή τιμή διαγράφει τη γραμμή που ισχύει και επαναφέρει την προεπιλογή. (Auth roles: System)
         * @param {ReturnSettingUpdateArgs} [ReturnSettingUpdateArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(ReturnSettingUpdateArgs, options) {
            return localVarFp.put(ReturnSettingUpdateArgs, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReturnSettingsApi - object-oriented interface
 * @export
 * @class ReturnSettingsApi
 * @extends {BaseAPI}
 */
class ReturnSettingsApi extends BaseAPI {
    /**
     *
     * @summary Όλες οι μεταβλητές του module με την τιμή τους για το ενεργό site. (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnSettingsApi
     */
    getAll(options) {
        return ReturnSettingsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Η ακύρωση της cache γίνεται <b>ρητά</b>, όχι με `CacheInvalidationActionFilter`. Το φίλτρο καλεί `ClearInvalidCache`, που διαβάζει τον `CachedEntitiesControl` από δική του σύνδεση και <i>προσπερνά</i> κάθε tag γραμμένο τα τελευταία `InvalidationSettleSeconds` — δηλαδή ακριβώς αυτό που μόλις έγραψε ο trigger του `Settings`. Το αποτέλεσμα θα ήταν το `ReturnSettings-{siteId}` να μείνει μπαγιάτικο μέχρι το επόμενο πέρασμα του `CachingHostedService`. Το `CheckCacheValidity` είναι in-memory και άμεσο, και είναι το μοτίβο που ήδη χρησιμοποιούν οι controllers με ρύθμιση που πρέπει να ισχύσει μέσα στο ίδιο request. Χωρίς `UnitOfWorkActionFilter`: μία μόνο εγγραφή, την οποία κάνει commit η ίδια η υπηρεσία, όπως και ο `SettingsController`.
     * @summary Αποθηκεύει μία μεταβλητή. Κενή τιμή διαγράφει τη γραμμή που ισχύει και επαναφέρει την προεπιλογή. (Auth roles: System)
     * @param {ReturnSettingUpdateArgs} [ReturnSettingUpdateArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnSettingsApi
     */
    put(ReturnSettingUpdateArgs, options) {
        return ReturnSettingsApiFp(this.configuration).put(ReturnSettingUpdateArgs, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ReturnSettingsApi, ReturnSettingsApiAxiosParamCreator, ReturnSettingsApiFactory, ReturnSettingsApiFp };
//# sourceMappingURL=return-settings-api.js.map
